import BaseTextInputEditor from '../BaseTextInputEditor';

export class PercentageInputEditor extends BaseTextInputEditor {
  getCellCustomStyle(): string {
    return 'custom-percentage-editor';
  }
}
